module.exports = __webpack_public_path__ + "img/cloud-wind-moon.a3c0eaac.svg";